// @spec POL-STR-001
// Policy library index route

import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { PolicyLibraryPage } from '@/features/policies/components/PolicyLibraryPage';

const policyListSearchSchema = z.object({
  uploadId: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/policies/')({
  validateSearch: policyListSearchSchema,
  component: PolicyLibraryPage,
});
